import {
  Breakpoint,
  Button,
  ButtonSizeType,
  ButtonStyleType,
  CourseType,
  ICourseOption,
  useWindowResize
} from "@into-discovery/browsewebshared";
import { deviceDetect } from "@into-discovery/browsewebshared/src/data/device-detect";
import React, { useState } from "react";
import ProgramIntakes from "/app/_components/atoms/search/program-intakes/program-intakes";
import { useTranslations } from "next-intl";
import { Link } from "/navigation";
import color from "../../../../styles/_helpers/branding.module.scss";
import { generateApplyURL } from "../../../../utils/generate-apply-url";

type Props = {
  courseOption: ICourseOption;
  brandId: string;
  disableCourseLink: boolean;
  brandName: string;
  brandCountry: string;
  brandPrimaryColor: string;
  themeColor: string;
  invertedTheme: boolean;
  handleApplyClick: (toggleModal: boolean, courseName: string, courseApplyURL: string) => void;
};

export default function PathwayOptionRow({
  courseOption,
  brandId,
  disableCourseLink,
  brandCountry,
  brandPrimaryColor,
  themeColor,
  invertedTheme,
  handleApplyClick
}: Props) {
  const [isBreakpointUp, setIsBreakpointUp] = useState(!deviceDetect.isMobile);

  useWindowResize((newWidth) => setIsBreakpointUp(newWidth >= Breakpoint.Large), 100);

  const translate = useTranslations(`Common`);

  if (!courseOption) {
    return null;
  }

  const courseSynonym: string = brandCountry === "US" ? "programs" : "courses";

  return (
    <div className="program-row d-flex flex-lg-row flex-column">
      <div className="col-lg-4 col-12 mb-3 mb-lg-0">
        <div
          role="navigation"
          aria-label={`Program Link for ${courseOption?.name}`}
          className="d-flex pe-0 pe-md-5 justify-content-between"
        >
          <h4 className="m-0 font-family-lato fw-normal">
            {disableCourseLink ? (
              <> {courseOption.name}</>
            ) : (
              <Link
                href={`/${courseOption.programGroup === CourseType.InternationalDirect ? `summary` : courseSynonym}/${courseOption.slug}`}
                className="d-inline-block"
              >
                {courseOption.name}
              </Link>
            )}
          </h4>
        </div>
      </div>
      <div className="col-lg-4 col-12 mb-3 mb-lg-0">
        <div className="pe-0 pe-md-5">
          {!isBreakpointUp && <h6 className="text-color-muted font-family-lato fw-normal mb-1">Next 3 Start Dates</h6>}
          {courseOption.intakes?.length > 0 && (
            <ProgramIntakes programName={courseOption?.name} intakes={courseOption?.intakes} />
          )}
        </div>
      </div>
      <div className="col-lg-4 col-12 d-flex justify-content-lg-end justify-content-between">
        <div>
          <Button
            buttonID={`${courseOption.slug}-${courseOption.outcomeId}`}
            buttonStyle={!isBreakpointUp ? ButtonStyleType.Outline : ButtonStyleType.Text}
            buttonSize={ButtonSizeType.Medium}
            copyColor={invertedTheme ? brandPrimaryColor : themeColor}
            outlineColor={invertedTheme ? brandPrimaryColor : themeColor}
            backgroundColor={color.white}
            hoverBackgroundColor={invertedTheme ? brandPrimaryColor : themeColor}
            activeBackgroundColor={invertedTheme ? brandPrimaryColor : themeColor}
            buttonAriaLabel={`Apply Program Link for ${courseOption.name}`}
            onClick={() => handleApplyClick(true, courseOption.name, generateApplyURL(brandId, courseOption.id))}
          >
            {translate(`header.nav.apply`)}
          </Button>
        </div>
      </div>
    </div>
  );
}
